<template lang="pug">
.arrControl
  Modal(v-model='value',width='860',:closable='false',:transfer='false',:footer-hide='true',:mask-closable='false')
    .Multiple
      .doFILLBLANKS
        .cont  任务中包含选择填空、单选、多选、问答、材料分析等多种题型，请仔细阅读题目完成哦～
        li().main-li
          Select.main-select(v-model='test')
            Option(value="统计局" :key="888")
          input.content-text(v-model='content')
          Icon(type="ios-close-circle",color='#E72020',size='20')
        button.addButton +  添加
    button.button(@click="start") 确定
    div.clear
  div.mask1()
  div(@click="start").mask2
    img(src="../../assets/Noviceguide/小手.png", alt="提示").finger
    div.text-Explain(style="z-index: 5555566;left: 78px;top: 169%;") 完成题目，点击确定
</template>
<script>
export default {
  data() {
    return {
      test: "统计局",
      content: "出生人口、人口结构、性别比例、出生率、死亡率等",
      value: true
    };
  },
  methods: {
    start() {
      this.$emit("start");
    }
  }
};
</script>
<style lang="stylus" scoped>
.text-Explain
  font-size 20px
  font-family STYuanti-SC-Bold, STYuanti-SC
  font-weight bold
  color rgba(255, 255, 255, 1)
  white-space nowrap
  position absolute
@keyframes myfirst
  from
    right 0%
    top -14%
  to
    right -10%
    top 0%
.finger
  // transition 1s
  animation myfirst 0.5s infinite
  animation-direction alternate
  position absolute
  right 0%
  z-index 55555556
  top -14%
.mask1
  position fixed
  box-shadow 0 0 0 2000px #00000099
  transform translate(-22%, -10%)
  right: -9px;
  position: absolute;
  top: 268px;
  width: 112px;
  height: 40px;
  z-index: 99999999;
  border-radius: 4px;
  cursor pointer
.mask2
  transform translate(-22%, -10%)
  right: -9px;
  position: absolute;
  top: 277px;
  width: 112px;
  height: 40px;
  z-index: 99999999;
  border-radius: 4px;
  cursor pointer
.button
  width:112px;
  height:40px;
  background:rgba(68,133,240,1);
  box-shadow:0px 0px 4px 2px rgba(255,255,255,0.8);
  border-radius:4px;
  font-size:14px;
  font-family:MicrosoftYaHeiUI;
  color:rgba(255,255,255,1);
  border: none;
  outline: none;
  float right
.arrControl
  width 860px
  background rgba(255, 255, 255, 1)
  position fixed
  // top 100px
  // bottom 75px
  left 0
  right 0
  margin auto
  z-index 100
  text-align left
  margin-bottom 80px

  // >>>.ivu-modal-body
  //   background #dddddd
  .com
    margin-bottom 20px
  .Multiple
    padding 36px 32px
.doFILLBLANKS
  width 100%
  .cont
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    line-height 20px
    margin-bottom 10px
  .main-select
    flex 0.2
    margin-right 20px
  .main-li
    display flex
    margin-bottom 12px
    align-items center
    .content-text
      width 596px
      flex 1
      height 32px
      background rgba(255, 255, 255, 1)
      border-radius 4px
      border 1px solid #dddddd
      outline none
      margin-right 4px
  .addButton
    width 100px
    height 32px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(58, 118, 210, 1)
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(58, 118, 210, 1)
    line-height 18px
    outline none
    margin-top 22px
</style>
